import React from 'react';
import './HelpText.styl';

export default class ConversationStyleTooltipContent extends React.PureComponent {
  render() {
    const {text, disclaimer} = this.props;
    return (
      <div className="rep-profile-help-text">
        <div>{text}</div>
        {disclaimer && <div className="disclaimer">{disclaimer}</div>}
      </div>
    );
  }
}
